import { render, staticRenderFns } from "./OlvidoContrasena.vue?vue&type=template&id=4a24fc4e&"
import script from "./OlvidoContrasena.vue?vue&type=script&lang=js&"
export * from "./OlvidoContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports